import React from 'react';
import { Hero } from '../components/Hero';
import { SocialProof } from '../components/SocialProof';
import { Diagnosis } from '../components/Diagnosis';
import { TheCure } from '../components/TheCure';
import { Guarantee } from '../components/Guarantee';
import { ContactForm } from '../components/ContactForm';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="min-h-screen bg-carbon font-inter" data-id="element-255">
      {/* Simple Header */}
      <header className="border-b border-gray-900 bg-carbon/95 backdrop-blur-sm sticky top-0 z-50" data-id="element-256">
        <div className="max-w-7xl mx-auto px-4 h-20 flex items-center justify-between" data-id="element-257">
          <img src="https://cdn.magicpatterns.com/uploads/2wzBsngBkoAKAmxHXDNPHE/IMG_6635.jpg" alt="Doctor Ecommerce" className="h-12 w-auto object-contain" data-id="element-258" />
          <a href="https://calendar.app.google/PYPdcRoYne7QrNJA7" target="_blank" rel="noopener noreferrer" className="text-sm font-semibold text-gold hover:text-white transition-colors" data-id="element-259">
            Agendar Llamada
          </a>
        </div>
      </header>

      <Hero data-id="element-260" />
      <SocialProof data-id="element-261" />
      <Diagnosis data-id="element-262" />
      <TheCure data-id="element-263" />
      <Guarantee data-id="element-264" />
      <ContactForm data-id="element-265" />
      <CTASection data-id="element-266" />
      <Footer data-id="element-267" />
    </main>;
}